/**
 * OcorrenciaTrackingResponsavelCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request, $} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'

/* TODO: review generated class */
@HttpExclude()
export class OcorrenciaTrackingResponsavelCollection extends PageCollection<
  OcorrenciaTrackingResponsavel
> {
  constructor() {
    super(OcorrenciaTrackingResponsavel)
  }

  add(item: OcorrenciaTrackingResponsavel) {
    this.items.push(item)
  }

  queryAsPage() {
    return this.listOcorrenciaTrackingResponsavel()
  }

  async listOcorrenciaTrackingResponsavel() {
    return await Request.get(`/admin/ocorrencia-tracking-responsavel`, {
      params: this.params,
    })
      .name('listOcorrenciaTrackingResponsavel')
      .as(this)
      .getResponse()
  }

  async listCsvOcorrenciaTrackingResponsavel() {
    return await Request.get(`/admin/ocorrencia-tracking-responsavel/csv`, {
      params: this.params,
    })
      .name('listCsvOcorrenciaTrackingResponsavel')
      .as(this)
      .getResponse()
  }

  async persistListOcorrenciaTrackingResponsavel(): Promise<number[]> {
    const url = `/admin/ocorrencia-tracking-responsavel/list`
    return await Request.post(url, this.items)
      .name('persistListOcorrenciaTrackingResponsavel')
      .asArrayOf<number>()
      .getData()
  }
}
